import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";

const minMax = require("dayjs/plugin/minMax");
const utc = require("dayjs/plugin/utc");

dayjs.extend(minMax);
dayjs.extend(utc);
dayjs.extend(isBetween);

export const dateText = ["日", "月", "火", "水", "木", "金", "土"];

export const formatDate = (
  date: string | Date,
  withDay?: boolean,
  format?: string,
) => {
  const formattedDate = dayjs(date).format(format ?? "YYYY/MM/DD");
  return withDay
    ? `${formattedDate}（${dateText[dayjs(date).day()]}）`
    : formattedDate;
};

export const formatDateTime = (
  dateTime: string | Date,
  withDay?: boolean,
  format?: string,
) => {
  const withDayFormat = format
    ? format.replace("{date}", `(${dateText[dayjs(dateTime).day()]})`)
    : `M/D (${dateText[dayjs(dateTime).day()]}) HH:mm`;

  return dayjs(dateTime).format(
    withDay ? withDayFormat : (format ?? "YYYY/MM/DD HH:mm:ss"),
  );
};

export const getCurrentDate = (format?: string) => {
  return formatDate(
    new Date(new Date().setHours(0, 0, 0, 0)),
    false,
    format ?? "YYYY-MM-DD",
  );
};

export const isInDateRange = (
  date: string | Date,
  startDate: string | Date,
  endDate: string | Date,
) => {
  return dayjs(date).isBetween(startDate, endDate, null, "[]");
};

export const isNowInDateRange = (
  startDate: string | Date,
  endDate: string | Date,
) => {
  const currentDate = formatDate(new Date(), false, "YYYY-MM-DD HH:mm:ss");
  return dayjs(currentDate).isBetween(startDate, endDate, null, "[]");
};

export const isSameDate = (date1: string | Date, date2: string | Date) => {
  return dayjs(date1).date() === dayjs(date2).date();
};

export const getDateTimeByHourOffset = (
  dateTime: string | Date,
  hourOffset: number,
): Date => {
  return dayjs(dateTime).add(hourOffset, "hour").toDate();
};
